import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import PlayerSearch from "../../components/players/PlayerSearch";
import { RouteConstants } from "../../constants/RouteConstants";

class PlayerContainer extends Component {
  componentDidMount() {
    const { trackingHelper } = this.props.rootStore;
    trackingHelper.trackPageView(RouteConstants.PLAYERS.title);
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="col-12 p-0 mb-4">
          <PlayerSearch />
        </div>
      </div>
    );
  }
}

PlayerContainer.propTypes = {
  rootStore: PropTypes.object.isRequired
};

export default inject("rootStore")(observer(PlayerContainer));
